window.Vue.filter('decimalInteger', function (value) {

    if (!value || value === '0') {
        return '0.00';
    }

    let zerofill = 3 - value.length;

    if (zerofill > 0) {
        value = '0'.repeat(zerofill) + value;
    }

    return value.substr(0, value.length - 2) + '.' + value.substr(-2);
});